import React from 'react'

const PublicFollowers = () => {
  return (
    <div>PublicFollowers</div>
  )
}

export default PublicFollowers